import "./global.js";

import * as Helper from "./classes/Helpers";
import * as TeamFilters from "./classes/components/team/TeamFilters";
import * as Marketo from "./classes/Marketo";
import PageAbout from "./classes/pages/PageAbout";
import PageGiftGuide from "./classes/pages/PageGiftGuide";
import AnimatedAppearingScroll from "./classes/AnimatedAppearingScroll";
import Animations from "./classes/Animations";

import SplitTextAnimation from "./classes/animation/SplitTextAnimation.js";
import initAlgoliaSearch from "./classes/search/index.js";
import TypewriterAnimation from "./classes/TypewriterAnimation";
import PageHomepage from "./classes/pages/PageHomepage";
import PageNews from "./classes/pages/PageNews";
import CounterAnimation from "./classes/animation/CounterAnimation.js";
import ParallaxImage from "./classes/animation/ParallaxImage";
import PostEvent from "./classes/posts/PostEvent";
import TemplateHub from "./classes/templates/TemplateHub";
import PageConnect from "./classes/pages/PageConnect";
import powerUserMenu from "./classes/PowerUserMenu";
import AiSceneHero from "./classes/AiSceneHero";
// import {PrintButtons} from "./classes/Helpers";
import EqualHeight from "./classes/EqualHeight";
import AnimatedDotsConnections from "./classes/verticals/AnimatedDotsConnections";
import PageCreatorStack from "./classes/pages/PageCreatorStack";
import PageCollegeTalent from "./classes/pages/PageCollegeTalent";
import { Hyperlinks } from "./classes/Hyperlinks";
import FeaturedEvents from "./classes/FeaturedEvents";
import SimpleLoadMore from "./classes/simple-tools/SimpleShowMore";
import SimpleShowAll from "./classes/simple-tools/SimpleShowAll";
import SimpleTabs from "./classes/simple-tools/SimpleTabs";
import BankingAiHero from "./classes/pages/banking-ai/BankingAiHero";
import Headless from "./classes/headless/Headless";
import PageAI from "./classes/pages/PageAI/PageAI";
import SimpleCountdown from "./classes/simple-tools/SimpleCountdown";
import PageAIRevolution from "./classes/pages/PageAIRevolution";
import CookieBanner from "./classes/CookieBanner";
import Analytics from "./classes/utils/Analytics";
import HeaderProgress from "./classes/helpers/HeaderProgress";
import HeightCalculator from "./classes/helpers/HeightCalculator";
import DarkModeSwitcher from "./classes/DarkModeSwitcher";

$(document).ready(function ($) {
  Helper.CloseAlertBanner();
  Helper.MobileNav();
  Helper.CustomSelect();
  Helper.OpenClose();
  Helper.Tabs();
  // Helper.Masonry();
  Helper.initInlineSVG();
  Helper.SwiperSlider();
  Helper.MobileSwiper();
  Helper.SocialNetworks();
  Helper.moveContent();
  Helper.Anchor();
  Helper.goTop();
  Helper.Hover();
  Helper.initLightbox();
  new HeightCalculator()
  new HeaderProgress();
  Helper.initM100();
  Helper.FixedHeader();
  Helper.eventCountdown();
  Helper.contentSwitcher();
  Helper.shortFullText();
  Helper.initShare();
  Helper.initToc();
  Helper.initVideoPopup();
  Helper.loadMorePodcasts();
  // Helper.initNewsLetters();
  Helper.initManageSubscriptions();
  Helper.loadMoreAnnouncements();
  Helper.loadMorePosts();
  // Helper.loadMoreEvents();
  Helper.filterPodcasts();
  Helper.initVideoModal();
  Marketo.initMarketo();
  TeamFilters.TeamFilters();
  Hyperlinks();
  Helper.txoSubmenu();
  Helper.VideoControl();
  Helper.LogoMobileWidth();
  Helper.ADMTimelineImage();
  Helper.Video();
  Helper.StickySharePanel();
  // Helper.Tooltip();
  Helper.MobileSubscribeOpener();
  Helper.AudioPlayers();
  Helper.tocSidebar();
  Helper.SlickSlider();
  Helper.tocSidebar();
  Helper.VHeight();
  Helper.WPFixes();
  Helper.ExecHiring();
  Helper.PrintButtons();
  Helper.initAnnotationsWidget();
  Helper.initTombstone();
  Helper.initCopyText();

  // AI page
  Helper.PortfolioFilters();
  Helper.ContentFilters();
  Helper.AlphaFilter();
  Helper.GlossarySearch();
  Helper.AudioPlayers();
  Helper.ToggleParent(".popup-opener", ".ai-founder", ".icon-close");
  Helper.HeroAnimation();
  Helper.OpenVideoModal();
  Helper.initFullBlock();
  // AI page end

  // HealthcareMeetFintech
  Helper.HxFSlider();

  Helper.initOuterHeight();

  Helper.initClickToTweet();

  CookieBanner.init();
  Analytics.initPlausibleAnalytics();

  // Simple-Tools
  SimpleLoadMore.init();
  SimpleShowAll.init();
  SimpleTabs.init();
  SimpleCountdown.init();

  DarkModeSwitcher.init();

  const aiHeroSliderEl = document.querySelector(".ai-hero .hero-slider");
  if (aiHeroSliderEl) {
    new AiSceneHero(aiHeroSliderEl);
  }

  const bankingAiHero = document.getElementById('banking-ai-hero-wrapper')
  if(bankingAiHero) {
      new BankingAiHero(bankingAiHero);
  }

  const about = document.getElementById("about-section");
  if (about) {
    new PageAbout();
  }

  const creatorStack = document.querySelector(".clf-creator-stack");
  if (creatorStack) {
    new PageCreatorStack();
  }

  const homepage = document.getElementById("homepage-content");
  if (homepage) {
    new PageHomepage(homepage);
  }

  const pageNews = document.querySelector(".page-news-latest");
  if (pageNews) {
    new PageNews();
  }

  const postEvent = document.querySelector(".post-event");
  if (postEvent) {
    new PostEvent(postEvent);
  }

  const templateHub = document.querySelector(".page-hub");
  if (templateHub) {
    new TemplateHub(templateHub);
  }

  const pageGiftGuideEl = document.querySelector(".page-gift-guide");
  if (pageGiftGuideEl) {
    new PageGiftGuide();
  }

  const pageConnect = document.querySelector(".page-connect");
  if (pageConnect) {
    new PageConnect(pageConnect);
  }

  const pageCollegeTalent = document.querySelector(".page-college-talent");
  if (pageCollegeTalent) {
    new PageCollegeTalent();
  }

  const featuredEvents = document.querySelector(".featured-events");
  if (featuredEvents) {
    new FeaturedEvents();
  }

  const pageAI = document.querySelector(".page-ai-a16z");
  if (pageAI) {
    new PageAI();
  }

  new AnimatedAppearingScroll();
  new Animations();

  const splitTextEl = document.querySelectorAll("[data-split-text]");
  if (splitTextEl && splitTextEl.length) {
    SplitTextAnimation.create({
      selector: ".homepage-content [data-split-text]",
      delay: 1,
    });
  }

  const typeWriterEl = document.querySelectorAll("[data-typewriter]");
  if (typeWriterEl && typeWriterEl.length) {
    new TypewriterAnimation(typeWriterEl);
  }

  const counterElements = document.querySelectorAll("[data-counter-animation]");
  if (counterElements && counterElements.length) {
    CounterAnimation.create({
      selector: counterElements,
      delay: 1,
    });
  }

  if (document.querySelectorAll("[data-parallax-img]")) {
    ParallaxImage.create({
      selector: document.querySelectorAll("[data-parallax-img]"),
    });
  }

  const dotsConnectionsEls = document.querySelectorAll(
    "[data-dots-connections]"
  );
  if (dotsConnectionsEls && dotsConnectionsEls.length) {
    dotsConnectionsEls.forEach((canvas) => {
      let baselineForeground = canvas.getAttribute(
        "data-connection-foreground"
      );
      if (baselineForeground === null || baselineForeground === "") {
        baselineForeground = "wave";
      }

      let baselineBackground = canvas.getAttribute(
        "data-connection-background"
      );
      if (baselineBackground === null || baselineBackground === "") {
        baselineBackground = "wave";
      }

      let connectionsForegroundOptions, connectionsBackgroundOptions;

      if (canvas.classList.contains("connections-footer")) {
        connectionsForegroundOptions = {
          minDots: 30,
          maxDots: 120,
          minDistance: 0.001,
          maxDistance: 0.25,
          yOffsetMin: -0.5,
          yOffsetMax: 0.4,
          baseLine: baselineForeground,
          color: "#ffffff",
          topOffset: 0.3,
          limitTop: true,
        };

        connectionsBackgroundOptions = {
          minDots: 20,
          maxDots: 120,
          minDistance: 0.005,
          maxDistance: 0.1,
          yOffsetMin: -0.5,
          yOffsetMax: 0.3,
          baseLine: baselineBackground,
          topOffset: 0.3,
          limitTop: true,
          blur: true,
          alpha: 0.3,
        };
      } else {
        connectionsForegroundOptions = {
          minDots: 30,
          maxDots: 130,
          minDistance: 0.0035,
          maxDistance: 0.2,
          yOffsetMin: -0.3,
          yOffsetMax: 0.1,
          baseLine: baselineForeground,
        };

        connectionsBackgroundOptions = {
          minDots: 20,
          maxDots: 100,
          minDistance: 0.005,
          maxDistance: 0.1,
          yOffsetMin: -0.5,
          yOffsetMax: 0.3,
          baseLine: baselineBackground,
          blur: true,
          alpha: 0.3,
        };
      }
      new AnimatedDotsConnections(
        canvas,
        connectionsForegroundOptions,
        connectionsBackgroundOptions,
        true
      );
    });
  }

  Headless.init();

  initAlgoliaSearch();
  new powerUserMenu();

  const equalHeight = document.querySelector("[data-equal-height]");
  if (equalHeight) {
    new EqualHeight();
  }

  // Inline Logos SVGs
  async function fetchSVG(url) {
    try {
      const response = await fetch(url);

      if (response.status !== 200) {
        console.warn(`Failed to fetch SVG from ${url}: ${response.statusText}`);
        return null;
      }

      let text = await response.text();

      // Check if the first line is an HTML doctype declaration
      if (text.startsWith("<!DOCTYPE html>")) {
        console.warn(
          `The content fetched from ${url} appears to be an HTML document, not an SVG.`
        );
        return null;
      }

      text = text.replace(/<\?xml.*?\?>/, "").trim();

      // Parse SVG and add viewBox if missing
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "image/svg+xml");
      const svgElement = doc.querySelector("svg");

      if (
        !svgElement.getAttribute("viewBox") &&
        svgElement.getAttribute("width") &&
        svgElement.getAttribute("height")
      ) {
        const width = svgElement.getAttribute("width");
        const height = svgElement.getAttribute("height");
        svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
      }

      const serializer = new XMLSerializer();
      return serializer.serializeToString(svgElement);
    } catch (error) {
      console.error(`Error fetching SVG from ${url}: ${error}`);
      return null;
    }
  }

  async function inlineSVGInBatch(batchSize = 10) {
    const elements = Array.from(
      document.querySelectorAll("[data-inline-svg-logo]")
    );

    for (let i = 0; i < elements.length; i += batchSize) {
      const batch = elements.slice(i, i + batchSize);

      const fetchPromises = batch.map((element) => {
        const url = element.getAttribute("data-inline-svg-logo");
        return fetchSVG(url).then((svgText) => {
          if (svgText !== null) {
            element.innerHTML = svgText;
          }
        });
      });

      // Wait for this batch to complete
      await Promise.all(fetchPromises);
    }
  }

  inlineSVGInBatch().then(() => {
    // console.log('All SVGs inlined.');
  });

  if(document.querySelector('.template-ai-revolution')) {
    new PageAIRevolution();
  }
});
